'use strict';

var React = require('react');

var SvgProductsMajor = function SvgProductsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 1h6a2 2 0 0 1 2 2v6a2.99 2.99 0 0 1-.879 2.122l-7 7a3 3 0 0 1-4.242 0l-5-5a3 3 0 0 1 0-4.243l7-7a2.991 2.991 0 0 1 2.121-.879Zm3 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  }));
};

exports.SvgProductsMajor = SvgProductsMajor;
